import React, { useState } from 'react';
import SectionHeader from '../components/SectionHeader';
import Reveal from '../components/Reveal';
import { animals } from '../mock';

export default function Animals() {
  const [active, setActive] = useState(null);

  return (
    <div>
      <div className="relative h-[46vh] min-h-[340px] bg-cover bg-center" style={{ backgroundImage: `url(https://images.unsplash.com/photo-1548417153-e49c8d900980?crop=entropy&cs=srgb&fm=jpg&q=85)` }}>
        <div className="absolute inset-0 bg-[#1a1108]/70" />
        <div className="container-x relative z-10 h-full flex flex-col justify-center">
          <span className="eyebrow text-[#f0b040]">Wildlife</span>
          <h1 className="font-display text-5xl md:text-6xl text-[#fff8ec] font-bold">Animals of the Safari</h1>
        </div>
      </div>

      <section className="section">
        <div className="container-x">
          <Reveal>
            <SectionHeader center eyebrow="Our Residents" title="Meet the Wild Family" subtitle="From regal lions to elusive leopards, Etawah Safari showcases the astounding diversity of Indian wildlife." />
          </Reveal>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {animals.map((a, i) => (
              <Reveal key={a.name} delay={i * 90}>
                <div className="card-tilt rounded-lg overflow-hidden bg-white shadow-md cursor-pointer" onClick={() => setActive(a)}>
                  <div className="h-72 overflow-hidden">
                    <img src={a.img} alt={a.name} className="img-zoom w-full h-full object-cover" />
                  </div>
                  <div className="p-6">
                    <h3 className="font-display text-2xl text-[#2b1d0e]">{a.name}</h3>
                    <p className="text-xs italic text-[#8b6520] mb-3">{a.scientific}</p>
                    <p className="text-sm text-[#5c4020] leading-relaxed">{a.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {active && (
        <div className="fixed inset-0 bg-[#1a1108]/85 z-[100] flex items-center justify-center p-4" onClick={() => setActive(null)}>
          <div className="bg-white rounded-lg max-w-2xl w-full overflow-hidden shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <img src={active.img} alt={active.name} className="w-full h-80 object-cover" />
            <div className="p-8">
              <h3 className="font-display text-3xl text-[#2b1d0e]">{active.name}</h3>
              <p className="italic text-[#8b6520] mb-4">{active.scientific}</p>
              <p className="text-[#3d2a12] leading-relaxed">{active.desc}</p>
              <button onClick={() => setActive(null)} className="mt-6 btn-primary">Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
